import Header from './Header.component';

export default Header;
